export const env = process.env.NODE_ENV === 'production' ? {
  backendUrl: 'https://api.wejustspeak.com:30100',
  audio: true,
  testRoutes: false,
  environment: 'prod'
} : {
  backendUrl: `http://${location.hostname}:30100`,
  audio: false,
  testRoutes: true,
  environment: 'dev'
}
